import React from 'react';
import { useParams } from 'react-router-dom';
import './CollectionPage.css';
import ProductGrid from '../components/ProductGrid';
import { catalog } from '../data/products';

const CollectionPage = ({ categoryKey }) => {
  const { subCategory } = useParams();
  const collection = catalog[categoryKey];
  const activeSubcategory = subCategory || 'all';

  if (!collection) {
    return (
      <div className="collection-page">
        <div className="collection-hero">
          <h1>Collection not found</h1>
          <p>We could not find the collection you were looking for.</p>
        </div>
      </div>
    );
  }

  const visibleProducts =
    activeSubcategory === 'all'
      ? collection.products
      : collection.products.filter(
          (product) => product.subcategory === activeSubcategory
        );

  return (
    <div className="collection-page">
      <div className="collection-hero">
        <p className="eyebrow">Fresh from Shapes United</p>
        <h1>{collection.title}</h1>
        <p>
          Shop the latest adaptive and sensory-friendly pieces curated straight
          from The Shapes United catalogue.
        </p>
        {activeSubcategory !== 'all' && (
          <p className="subcategory-label">
            Showing {activeSubcategory.toUpperCase()}
          </p>
        )}
      </div>

      {visibleProducts.length > 0 ? (
        <ProductGrid products={visibleProducts} />
      ) : (
        <div className="collection-empty">
          <p>
            No products found in this category yet. Try another filter or check
            back soon.
          </p>
        </div>
      )}
    </div>
  );
};

export const MensCollection = () => <CollectionPage categoryKey="mens" />;
export const WomensCollection = () => <CollectionPage categoryKey="womens" />;
export const KidsCollection = () => <CollectionPage categoryKey="kids" />;

export default CollectionPage;
